/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        modal: {
            borderRadius: {
                value: "0",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "10px",
                            blur: "32px",
                            spread: "-6px",
                            color: "#00000020",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "4px",
                            blur: "4px",
                            spread: "-2px",
                            color: "#00000008",
                        },
                    ],
                    stringValue: "0px 10px 32px -6px #00000020, 0px 4px 4px -2px #00000008",
                },
                type: "shadow",
            },
            maxWidth: {
                value: "440px",
                type: "dimension",
            },
            header: {
                paddingHorizontal: {
                    value: "20px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
                gap: {
                    value: "8px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                fontSize: {
                    value: "1.375rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.625rem",
                    type: "dimension",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            content: {
                padding: {
                    value: "20px",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                borderWidth: {
                    value: "2px",
                    type: "dimension",
                },
                borderColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                borderTopStyle: {
                    value: "solid",
                    type: "string",
                },
                borderBottomStyle: {
                    value: "solid",
                    type: "string",
                },
            },
            footer: {
                paddingHorizontal: {
                    value: "24px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
            },
            overlay: {
                backgroundColor: {
                    value: "#00000080",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
